import {
  createBrowserRouter,
  createRoutesFromElements,
  useRouteError,
  Route,
  RouterProvider,
} from "react-router-dom";

import * as loaders from "src/utils/routeLoader";
import pageURL from "src/constants/pageURL";

import Loading from "src/components/Loading";
import React, { Suspense } from "react";
import AppCleanLayoutWithBg from "src/Layout/AppCleanLayoutWithBg";

const ErrorPage = React.lazy(async () => {
  return import("./pages/Error");
});

function ErrorBoundary() {
  const error = useRouteError();
  console.error("we caught an error on 404", error);
  return <ErrorPage />;
}

const SinglePostPage = React.lazy(async () => {
  return import("./pages/SinglePost");
});

const AllPostPage = React.lazy(async () => {
  return import("./pages/AllPost");
});

// const SearchPostPage = React.lazy(async () => {
//   return import("./pages/SearchPost");
// });

const Root = (
  <Route errorElement={<ErrorBoundary />}>
    <Route element={<AppCleanLayoutWithBg />}>
      <Route
        loader={loaders.allPostsLoader}
        path={pageURL.home}
        element={<AllPostPage />}
      ></Route>
      <Route
        loader={loaders.pageLoader}
        path={pageURL.pageSlug}
        element={<AllPostPage />}
      ></Route>
      <Route
        loader={loaders.categoryIdLoader}
        path={pageURL.categoryId}
        element={<AllPostPage />}
      ></Route>
      <Route
        loader={loaders.searchTermLoader}
        path={pageURL.searchTerm}
        element={<AllPostPage />}
      ></Route>
      <Route
        loader={loaders.postLoader}
        path={pageURL.postDateSlug}
        element={<SinglePostPage />}
      ></Route>
      <Route
        loader={loaders.postLoader}
        path={pageURL.postSlug}
        element={<SinglePostPage />}
      ></Route>
      <Route
        loader={loaders.postLoader}
        path={pageURL.directPostSlug}
        element={<SinglePostPage />}
      ></Route>
    </Route>
  </Route>
);

const router = createBrowserRouter(createRoutesFromElements(Root));

const RoutesContainer = () => {
  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default RoutesContainer;
